import React, { useState, useEffect } from 'react'
import { Row, Form, Button, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import { useCreateSubjectMutation } from '../../slices/teachers/subjectApiSlice';
import { useCreatePlanMutation } from '../../slices/teachers/planApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const TeacherNewSubject = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [tittle, setTittle] = useState('');
    const [description, setDescription] = useState('');
    const [teachername, setTeacherName] = useState('');

    const [subtopic1, setSubtopic1] = useState('');
    const [subtopic2, setSubtopic2] = useState('');
    const [subtopic3, setSubtopic3] = useState('');
    const [subtopic4, setSubtopic4] = useState('');
    const [subtopic5, setSubtopic5] = useState('');
    const [subtopic6, setSubtopic6] = useState('');
    const [subtopic7, setSubtopic7] = useState('');
    const [subtopic8, setSubtopic8] = useState('');
    const [subtopic9, setSubtopic9] = useState('');

    const [questions1, setQuestions1] = useState('');
    const [price1, setPrice1] = useState('');
    const [questions2, setQuestions2] = useState('');
    const [price2, setPrice2] = useState('');
    const [questions3, setQuestions3] = useState('');
    const [price3, setPrice3] = useState('');

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    const [createSubject, { isLoading: loadingCreateSubject }] = useCreateSubjectMutation();
    const [createPlan, { isLoading: loadingCreatePlan, error }] = useCreatePlanMutation();

    const [isvideo, setIsvideo] = useState(false); 
    const [videoFile, setVideoFile] = useState(null); 
    const [loading, setLoading] = useState(false); 

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        } else {
            setTeacherName(teacherInfo.firstname + ' ' + teacherInfo.lastname);
        }
    }, [navigate, teacherInfo]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          if (file.type == 'video/mp4' ||  file.type == 'video/quicktime' || file.type == 'video/avi') { 
            setIsvideo(true); 
            setVideoFile(event.target.files[0]); 
          } else {  
            toast.error('Please upload a mp4 or quicktime or avi video file ');
          }
        } 
      };


    const submitHandler = async (e) => {
        e.preventDefault()
        setLoading(true);
        if (tittle == '') { toast.error('Please enter a Title'); return; } 
        if (description == '') { toast.error('Please enter a Description'); return; }
        if (subtopic1 == '' && subtopic2 == '' && subtopic3 == '' && subtopic4 == '' && subtopic5 == '' && subtopic6 == '' && subtopic7 == '' && subtopic8 == '' && subtopic9 == '') { 
            toast.error('Please setup at least one Subtopic '); 
            return; 
        }
        if (price1 == '' && price2 == '' && price3 == '') { toast.error('Please setup at least one subscription plan '); return; }
        try {
            const res = await createSubject({ 
                tittle, 
                description, 
                teachername, 
                subtopics: {
                    subtopic1, 
                    subtopic2, 
                    subtopic3, 
                    subtopic4, 
                    subtopic5,
                    subtopic6,
                    subtopic7,
                    subtopic8,
                    subtopic9 
                }
            }).unwrap();
            const res2 = await createPlan({
                subjectId: res._id,
                teachername: res.teachername,
                subjectname: tittle,
                questions1,
                price1,
                questions2,
                price2,
                questions3,
                price3
            }).unwrap();
            if (isvideo) {
                var fd = new FormData();
                fd.append('upl', videoFile);
                fd.append('id', res._id);
                fetch('/api/upload/uploadsubjectvideo',
              {
                  method: 'post',
                  body: fd,
                })
                .then(response => response.json())
                .then(data => {
                  toast.success('Video Saved');
                  setLoading(false);
                })
                .catch(error => {
                  toast.success('Error uploading video');
                  setLoading(false);
                });
              } else {  
                toast.error('Please upload a mp4 or quicktime or avi video file');  
              }
            toast.success('Subject Created');
            navigate('/teachersubjects')
        } catch (err) {
            toast.error(err?.data?.message || err.error.message);
        }
    };

    return (
    <div>
        <TeacherNavbar />
        <div className="main-content" id="panel">
        <TeacherHeader />
        <br /><br /><br /><br /><br />
            <div className="container-fluid mt--6">
                <div className="row">
                <div className="col-xl-10 offset-xl-1 newSubj ">  
                        <div className="card-wrapper">
                            <div className="card ">
                                <div className=""><br /><br />
                                    <h1 className="mb-0 centerTitle  tittleColor4">
                                    <span className='tittleColor'>Create  new subject
                                        </span>
                                        </h1><br /><br />
                                </div>
                                { loading ? ( 
                                        <Loader />
                                    ) : error ? (
                                        <Message variant='danger'>
                                            {error?.data?.message || error.error}
                                        </Message>
                                    ) : (                                
                                <div className="card-body">
                                    <Form onSubmit={submitHandler}>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                                                </div>
                                                <input 
                                                    className="form-control emailForm" 
                                                    placeholder="Title" 
                                                    type="text" 
                                                    value={tittle}
                                                    onChange={(e) => setTittle(e.target.value)}   
                                                                                                                        
                                                />
                                            </div>
                                        </div><br />
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-warning"><i className="ni ni-archive-2 navText"></i></span>
                                                </div>
                                                <textarea 
                                                    className="form-control emailForm" 
                                                    placeholder="Description" 
                                                    rows="3"
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}                                          
                                                />
                                            </div>
                                        </div><br />
                                        <div className="form-group">
                                        <label for="exampleInputEmail1">Upload a video describing your subject</label>

                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                                                </div>                                                
                                                <input 
                                                id='exampleInputEmail1'
                                                type="file" 
                                                className="form-control" 
                                                onChange={handleFileChange} 
                                                />
                                            </div>
                                        </div><br />                                        
                                        <div className=""><br />
                                            <h4 className="mb-0 centerTitle  tittleColor4">
                                            <span className='tittleColor'> 
                                                Subtopics your stutends can ask you about
                                            </span>
                                                </h4><br /><br />
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-success"><i className="ni ni-ungroup navText"></i></span>
                                                </div>
                                                <textarea 
                                                    className="form-control emailForm" 
                                                    placeholder="Subtopic 1" 
                                                    rows="3"
                                                    value={subtopic1}
                                                    onChange={(e) => setSubtopic1(e.target.value)}                                          
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-success"><i className="ni ni-ungroup navText"></i></span>
                                                </div>
                                                <textarea 
                                                    className="form-control emailForm" 
                                                    placeholder="Subtopic 2" 
                                                    rows="3"
                                                    value={subtopic2}
                                                    onChange={(e) => setSubtopic2(e.target.value)}                                          
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-success"><i className="ni ni-ungroup navText"></i></span>
                                                </div>
                                                <textarea 
                                                    className="form-control emailForm" 
                                                    placeholder="Subtopic 3" 
                                                    rows="3"
                                                    value={subtopic3}
                                                    onChange={(e) => setSubtopic3(e.target.value)}                                          
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-success"><i className="ni ni-ungroup navText"></i></span>
                                                </div>
                                                <textarea 
                                                    className="form-control emailForm" 
                                                    placeholder="Subtopic 4" 
                                                    rows="3"
                                                    value={subtopic4}
                                                    onChange={(e) => setSubtopic4(e.target.value)}                                          
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-success"><i className="ni ni-ungroup navText"></i></span>
                                                </div>
                                                <textarea 
                                                    className="form-control emailForm" 
                                                    placeholder="Subtopic 5" 
                                                    rows="3"
                                                    value={subtopic5}
                                                    onChange={(e) => setSubtopic5(e.target.value)}                                          
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-success"><i className="ni ni-ungroup navText"></i></span>
                                                </div>
                                                <textarea 
                                                    className="form-control emailForm" 
                                                    placeholder="Subtopic 6" 
                                                    rows="3"
                                                    value={subtopic6}
                                                    onChange={(e) => setSubtopic6(e.target.value)}                                          
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-success"><i className="ni ni-ungroup navText"></i></span>
                                                </div>
                                                <textarea 
                                                    className="form-control emailForm" 
                                                    placeholder="Subtopic 7" 
                                                    rows="3"
                                                    value={subtopic7}
                                                    onChange={(e) => setSubtopic7(e.target.value)}                                          
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-success"><i className="ni ni-ungroup navText"></i></span>
                                                </div>
                                                <textarea 
                                                    className="form-control emailForm" 
                                                    placeholder="Subtopic 8" 
                                                    rows="3"
                                                    value={subtopic8}
                                                    onChange={(e) => setSubtopic8(e.target.value)}                                          
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-success"><i className="ni ni-ungroup navText"></i></span>
                                                </div>
                                                <textarea 
                                                    className="form-control emailForm" 
                                                    placeholder="Subtopic 9" 
                                                    rows="3"
                                                    value={subtopic9}
                                                    onChange={(e) => setSubtopic9(e.target.value)}                                          
                                                />
                                            </div>
                                        </div><br /><br /><br />
                                        <div className=""><br />
                                            <h2 className="mb-0 centerTitle  tittleColor4">
                                            <span className='tittleColor4'> 
                                                Create subscription plans ( up to 3 )
                                            </span>                                            
                                                </h2>
                                                <p className=" text-info text-center small">
                                                Don't forget to setup your payments account to start receiving subscribers and payments
                                                </p>
                                                <br /><br />
                                        </div>
                                        <div className=""><br />
                                            <h5 className="mb-0 centerTitle  tittleColor4">
                                            <span className='tittleColor4'>
                                                Plan 1
                                            </span>
                                                </h5><br /><br />
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-primary"><i className="ni ni-ui-04 navText"></i></span>
                                                </div>
                                                <input 
                                                    className="form-control emailForm" 
                                                    placeholder="Number of Monthly Questions a student can ask you (5 min each)" 
                                                    type="number" 
                                                    value={questions1}
                                                    onChange={(e) => setQuestions1(e.target.value)}                                              
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-info"><i className="ni ni-shop navText"></i></span>
                                                </div>
                                                <input 
                                                    className="form-control emailForm" 
                                                    placeholder="Monthly Price $ " 
                                                    type="number" 
                                                    value={price1}
                                                    onChange={(e) => setPrice1(e.target.value)}                                              
                                                />
                                            </div>
                                        </div><br />
                                        <div className=""><br />
                                            <h5 className="mb-0 centerTitle  tittleColor4">
                                            <span className='tittleColor4'>
                                                Plan 2
                                            </span>
                                                </h5><br /><br />
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-primary"><i className="ni ni-ui-04 navText"></i></span>
                                                </div>
                                                <input 
                                                    className="form-control emailForm" 
                                                    placeholder="Number of Monthly Questions a student can ask you (5 min each)" 
                                                    type="number" 
                                                    value={questions2}
                                                    onChange={(e) => setQuestions2(e.target.value)}                                              
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-info"><i className="ni ni-shop navText"></i></span>
                                                </div>
                                                <input 
                                                    className="form-control emailForm" 
                                                    placeholder="Monthly Price $ " 
                                                    type="number" 
                                                    value={price2}
                                                    onChange={(e) => setPrice2(e.target.value)}                                              
                                                />
                                            </div>
                                        </div><br />
                                        <div className=""><br />
                                            <h5 className="mb-0 centerTitle  tittleColor4">
                                            <span className='tittleColor4'>
                                                Plan 3
                                            </span>
                                                </h5><br /><br />
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-primary"><i className="ni ni-ui-04 navText"></i></span>
                                                </div>
                                                <input 
                                                    className="form-control emailForm" 
                                                    placeholder="Number of Monthly Questions a student can ask you (5 min each)" 
                                                    type="number" 
                                                    value={questions3}
                                                    onChange={(e) => setQuestions3(e.target.value)}                                              
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group input-group-merge input-group-alternative mb-3">
                                                <div className="input-group-prepend moveInput">
                                                <span className="input-group-text bg-gradient-info"><i className="ni ni-shop navText"></i></span>
                                                </div>
                                                <input 
                                                    className="form-control emailForm" 
                                                    placeholder="Monthly Price $" 
                                                    type="number" 
                                                    value={price3}
                                                    onChange={(e) => setPrice3(e.target.value)}                                              
                                                />
                                            </div>
                                        </div><br />
                                        <div className='mycard'><br /><br /><br /><br />
                                            <Button  type='submit' variant="primary rounded-pill bg-gradient-info btn-lg "> 
                                                Create Subject  
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            )} 

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default TeacherNewSubject
